"use client";

import React from "react";

// Dışarıdan Beklediğimiz Verilerin Tipleri
export interface PartnerItem {
    id: string | number;
    name: string;
    image: string;
}

interface FeaturedPartnersProps {
    title?: string;
    subtitle?: string;
    description?: string;
    partners: PartnerItem[];
}

export default function FeaturedPartners({
    title = "Güvenilen Ortaklıklar",
    subtitle = "Sektörün önde gelen sigorta şirketleriyle iş birliklerimiz sayesinde size en iyi hizmeti sunmanın gururunu yaşıyoruz.",
    description = "Sektördeki güçlü iş birliklerimiz sayesinde, müşterilerimize en geniş sigorta ürünü yelpazesini ve en uygun fiyat garantisini sunma imkanına sahibiz.",
    partners
}: FeaturedPartnersProps) {

    // Eğer gösterilecek partner yoksa bileşeni hiç render etme (Boşluk kalmasın)
    if (!partners || partners.length === 0) {
        return null;
    }

    return (
        <section className="py-16 md:py-20 px-4 sm:px-6 relative overflow-hidden"
            style={{ background: `linear-gradient(to bottom, #ffffff, var(--color-primary)0A)` }}> {/* 0A = %4 Opaklık */}

            {/* Dinamik Dekoratif Elementler (Acentenin rengini alır) */}
            <div className="absolute top-6 md:top-10 left-4 md:left-10 w-48 md:w-72 h-48 md:h-72 rounded-full blur-2xl md:blur-3xl opacity-20" style={{ backgroundColor: 'var(--color-primary)' }}></div>
            <div className="absolute bottom-6 md:bottom-10 right-4 md:right-10 w-64 md:w-96 h-64 md:h-96 rounded-full blur-2xl md:blur-3xl opacity-15" style={{ backgroundColor: 'var(--color-secondary, var(--color-primary))' }}></div>

            <div className="container mx-auto max-w-7xl relative z-10">
                {/* Başlık */}
                <div className="text-center mb-12 md:mb-16">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 md:mb-6">
                        {title.split(' ')[0]} <span style={{ color: 'var(--color-primary)' }}>{title.split(' ').slice(1).join(' ')}</span>
                    </h2>
                    <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base lg:text-lg px-4">
                        {subtitle}
                    </p>
                </div>

                {/* Logo Carousel Container */}
                <div className="relative overflow-hidden py-4 w-full group">
                    {/* Kenar Gölgeleri (Tıklamayı engellememesi için pointer-events-none eklendi) */}
                    <div className="absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-linear-to-r z-10 pointer-events-none"></div>
                    <div className="absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-linear-to-l z-10 pointer-events-none"></div>

                    {/* ANA KAYDIRICI KUTU (İçinde 2 set barındırır, w-max olması şarttır) */}
                    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">

                        {/* 1. SET (ORİJİNAL LİSTE) */}
                        <div className="flex gap-6 md:gap-12 px-3 md:px-6">
                            {partners.map((partner, idx) => (
                                <div
                                    key={`original-${partner.id}-${idx}`}
                                    className="shrink-0 w-28 h-14 md:w-40 md:h-20 bg-white border border-slate-200 rounded-lg md:rounded-xl p-2 md:p-4 flex items-center justify-center shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
                                >
                                    <div className="relative w-full h-full flex items-center justify-center">
                                        <img
                                            src={partner.image || '/assets/images/placeholder-logo.png'}
                                            alt={partner.name || 'Partner Logo'}
                                            className="w-full h-full object-contain transition-all duration-300 opacity-90 hover:opacity-100"
                                            onError={(e) => {
                                                e.currentTarget.src = '/assets/images/placeholder-logo.png';
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* 2. SET (KOPYA LİSTE - Kusursuz döngü için birinci setin aynısı) */}
                        <div className="flex gap-6 md:gap-12 px-3 md:px-6" aria-hidden="true">
                            {partners.map((partner, idx) => (
                                <div
                                    key={`clone-${partner.id}-${idx}`}
                                    className="shrink-0 w-28 h-14 md:w-40 md:h-20 bg-white border border-slate-200 rounded-lg md:rounded-xl p-2 md:p-4 flex items-center justify-center shadow-sm :shadohoverw-md hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
                                >
                                    <div className="relative w-full h-full flex items-center justify-center">
                                        <img
                                            src={partner.image || '/assets/images/placeholder-logo.png'}
                                            alt={partner.name || 'Partner Logo'}
                                            className="w-full h-full object-contain transition-all duration-300  opacity-90 hover:opacity-100"
                                            onError={(e) => {
                                                e.currentTarget.src = '/assets/images/placeholder-logo.png';
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>

                {/* Alt Açıklama */}
                <div className="text-center mt-8 md:mt-12 max-w-3xl mx-auto">
                    <p className="text-slate-500 text-xs md:text-sm px-4">
                        {description}
                    </p>
                </div>
            </div>
        </section>
    );
}